import React from "react";
import { Routes, Route } from "react-router-dom";
import {
  Contact,
  Home,
  LogIn,
  SignUp,
  SingleCourse,
  Research,
  About,
  Functionary,
  FunctionaryDetail,
} from "./pages";
import E404 from "./components/errors/E404";

const ConfigRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/login" element={<LogIn />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/singlecourse" element={<SingleCourse />} />
      <Route path="/research/" element={<Research />} />
      <Route path="/functionary/" element={<Functionary />} />
      <Route path="/functionary/:id" element={<FunctionaryDetail />} />
      <Route path="/about/" element={<About />} />
      <Route path="/*" element={<E404 />} />
    </Routes>
  );
};

export default ConfigRoutes;
